export default __webpack_public_path__ + "static/body-09f5f4e1db927532979b1118771a2c4e.png";